export function validateSearchChannelV115(type, baseURL, config = {}) {
  if (Number(type) !== 55) return;
  let url;
  try { url = new URL(baseURL); } catch { /* handled below */ }
  if (!url || !['http:', 'https:'].includes(url.protocol) || url.username ||
      url.password || url.search || url.hash) {
    throw new Error('channel.edit.search_v115.endpoint_invalid');
  }
  if (config.edge_proxy || config.upstream_proxy || config.tailscale_server ||
      (config.egress_mode && config.egress_mode !== 'direct') ||
      config.outbound_client_profile_v95 || config.model_sync_v103 ||
      config.video_protocol_v1016 || config.openrouter_v1015) {
    throw new Error('channel.edit.search_v115.transport_invalid');
  }
  const engines = config.search_engines_v116;
  if (engines !== undefined && (!Array.isArray(engines) || engines.length > 8 ||
    new Set(engines).size !== engines.length || engines.some(engine =>
      typeof engine !== 'string' || !/^[a-z0-9][a-z0-9 _-]{0,63}$/.test(engine) || engine.trim() !== engine))) {
    throw new Error('channel.edit.search_v115.engines_invalid');
  }
}
